export default __webpack_public_path__ + "static/media/oven2-portrait.4ad1aa26.webp";